import { useData } from "../../runtime/provider";
import { useMutation } from "@tanstack/react-query";
import { RouterInputs } from "@utils/trpc";
import { captureException } from "@utils/captureException";
import { refreshGemsAfterUnlock } from "./useAccessCreateMusicUnlock";

type Input = RouterInputs["accesses"]["confirmMusicUnlock"];

/**
 * Grants paid-for music from the engine's order the moment its checkout
 * says it is done (LIS-1038): `granted`, or `pending` while the payment is
 * still processing (the engine's webhook grants it then).
 */
const useAccessConfirmMusicUnlock = () => {
  const data = useData();
  return useMutation({
    mutationFn: (input: Input) =>
      data.api.accesses.confirmMusicUnlock.mutate(input),
    onSuccess: ({ status }) => {
      if (status === "granted") refreshGemsAfterUnlock(data);
    },
    onError: (error, input) =>
      captureException(error, {
        channel: "error",
        area: "checkout",
        operation: "confirm-music-unlock",
        tags: { accessId: input.accessId },
      }),
  });
};

export default useAccessConfirmMusicUnlock;
